module.exports = __webpack_public_path__ + "img/sdg_es_(9).7c43827b.png";